export default [
  {
    path: '/main/reportrfidreaderdelay',
    meta: {
      tag: 'report_rfid_reader_delay',
      name: 'Relatório de Atraso Leitor RFID',
      breadcrumb: 'Relatório de Atraso Leitor RFID'
    },
    component: () => import(/* webpackChunkName: "report-rfid-reader-delay" */ '@/views/main/reports/rfidreaderdelay/Index.vue'),
    children: [
      {
        path: '',
        name: 'listrfidreaderdelay',
        meta: {
          tag: 'report_rfid_reader_delay',
          name: 'Relatório de Atraso Leitor RFID',
          menu: 'reports',
        },
        component: () => import(/* webpackChunkName: "report-rfid-reader-delay" */ '@/views/main/reports/rfidreaderdelay/List.vue'),
      }
    ]
  }
]
